import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";
import { EntregaObraClienteTermoModel } from "../../models/entrega_obra_cliente_termo";
import { IGetAllEntregaObraClienteTermoUseCase } from "../../../presentation/useCases/read/get_all_entrega_obra_cliente_termo_use_case";

/**
 * GetAllEntregaObraClienteTermoUseCase
 */

export class GetAllEntregaObraClienteTermoUseCase
  extends BasePaginatedUseCase<EntregaObraClienteTermoModel>
  implements IGetAllEntregaObraClienteTermoUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) {
    super();
  }

  async execute(idEntregaObraCliente: number): Promise<void> {
    const result = await this.repository.getAllEntregaObrasClienteTermos(idEntregaObraCliente);

    this._items = result.items;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
    this._totalItems = result.totalItems;
    this._totalPages = result.totalPages;
  }
}
